import request from '@/utils/request'

// 排行榜列表
export function getStudyRank(query) {
    return request({
        url: '/api/works/get_study_rank',
        method: 'get',
        params: query
    })
}

// 排行榜配置
export const getRankSet = (params) => request.get('/api/activity/get_rank_set', { params })